import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue } from '@gk/gk-modules';
import {
  MCGRNewRequestSettlementScopeControlName,
  MCGRSettlementScopeFormGroup,
} from './costs-section-form.model';

@Injectable({
  providedIn: 'root',
})
export class MCGRCostSctionFormArrayService {
  constructor(private formBuilder: UntypedFormBuilder) {}

  getFormGroup(): FormGroup<MCGRSettlementScopeFormGroup> {
    return this.formBuilder.group({
      [MCGRNewRequestSettlementScopeControlName.Scope]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.Amount]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
      [MCGRNewRequestSettlementScopeControlName.PercentageShare]:
        this.formBuilder.control(getDefaultControlValue(), [
          Validators.required,
        ]),
    });
  }
}
